// CSV export utilities

import { format } from 'date-fns';
import { formatDecimal } from './calculations';

/**
 * Export search results to CSV
 * @param {Array} results - Search results array
 * @param {string} filename - Filename for the CSV
 */
export const exportToCSV = (results, filename = 'search-results.csv') => {
  if (!results || results.length === 0) {
    console.warn('No data to export');
    return;
  }

  // Define CSV headers
  const headers = [
    'Type',
    'Transaction #',
    'Customer/Account',
    'Order No.',
    'Date',
    'Time',
    'Subtotal',
    'VAT',
    'Total'
  ];

  // Convert results to CSV rows
  const rows = results.map(row => {
    const customerName = row.account?.name || row.customer?.customer || '-';
    const date = row.timestamp ? format(new Date(row.timestamp), 'dd/MM/yyyy') : '-';
    const time = row.timestamp ? format(new Date(row.timestamp), 'HH:mm:ss') : '-';

    return [
      row.typeName || '',
      `${row.typeName} # ${row.id}`,
      customerName,
      row.order_number || '-',
      date,
      time,
      formatDecimal(row.subtotal),
      formatDecimal(row.vat),
      formatDecimal(row.total)
    ];
  });

  // Combine headers and rows
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
  ].join('\n');

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');

  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};
